import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/About.css';

function About() {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className="about">
      {/* Video Hero Section */}
      <section className="about-video-hero">
        <video
          className="about-video"
          src="3125396-uhd_3840_2160_25fps.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="about-video-overlay"></div>
        <div className="about-hero-content">
          <h1 className="about-title">About Us</h1>
          <p className="about-intro">
            We're a digital agency dedicated to transforming businesses through innovative web solutions, creative content, and data-driven strategies.
          </p>
        </div>
      </section>

      {/* About Description */}
      <section className="about-description">
        <div className="about-container">
          <p className="about-paragraph">
            At Namo Digital Hub, we specialize in crafting custom web solutions powered by cutting-edge AI technology. Our team of experienced developers, designers, and strategists work together to create digital experiences that drive real business results. Whether you're a startup looking to establish your online presence or an established business ready to scale, we've got the expertise to take you there.
          </p>
          <p className="about-paragraph">
            From AI-powered web development to high-quality video editing and lead generation campaigns, we provide end-to-end digital marketing and development services. Our mission is to help brands grow digitally by combining strategic thinking, creative excellence, and technical innovation. We don't just build websites—we build digital assets that generate revenue and foster long-term customer relationships.
          </p>
        </div>
      </section>

      {/* Services Cards */}
      <section className="about-services">
        <div className="about-container">
          <h2 className="services-heading">What We Do</h2>
          <div className="services-grid">
            {/* Card 1 */}
            <div className="service-card">
              <div className="card-icon">
                <i className="fas fa-code"></i>
              </div>
              <h3 className="card-title">AI Web Development</h3>
              <p className="card-description">
                Build intelligent, responsive websites powered by AI technology. We create custom web solutions that are fast, scalable, and optimized for conversions.
              </p>
            </div>

            {/* Card 2 */}
            <div className="service-card">
              <div className="card-icon">
                <i className="fas fa-video"></i>
              </div>
              <h3 className="card-title">Video Editing</h3>
              <p className="card-description">
                Professional video editing services that bring your content to life. From promotional videos to social media content, we deliver high-quality visual storytelling.
              </p>
            </div>

            {/* Card 3 */}
            <div className="service-card">
              <div className="card-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3 className="card-title">Lead Generation</h3>
              <p className="card-description">
                Data-driven lead generation campaigns that fill your pipeline with qualified prospects. We use advanced targeting and optimization to maximize your ROI.
              </p>
            </div>

            {/* Card 4 */}
            <div className="service-card">
              <div className="card-icon">
                <i className="fas fa-palette"></i>
              </div>
              <h3 className="card-title">Graphic Designing</h3>
              <p className="card-description">
                Creative graphic design services that elevate your brand identity. From logos to marketing materials, we craft visually stunning designs that make an impact.
              </p>
            </div>
          </div>
        </div>
      </section>


      <section className="journey-section">
      <div className="journey-container">

        <h2 className="journey-heading">
          Our <span>Journey</span>
        </h2>

        <p className="journey-subheading">
          From a vision to build impactful digital experiences to delivering
          high-performance solutions for clients worldwide.
        </p>

        <div className="journey-content">

          <p>
            The journey began with a simple yet powerful vision — to create a
            brand that delivers <strong>high-quality digital solutions</strong> 
            while helping businesses grow in the modern online world. What started 
            as a small initiative by a passionate founder soon turned into a 
            consistent learning process, where every project brought new 
            challenges, experiences, and opportunities. Through continuous 
            improvement and a deep understanding of client needs, the foundation 
            of a strong and reliable digital service brand was built.
          </p>

          <p>
            Over time, the focus expanded into areas like 
            <strong> AI-powered web development</strong>, 
            <strong> video editing</strong>, and 
            <strong> lead generation</strong>, allowing the brand to deliver 
            complete solutions under one roof. With dedication, creativity, and 
            a commitment to excellence, the founder successfully transformed 
            ideas into real-world results. Today, the journey continues with the 
            same passion — to innovate, grow, and help clients achieve success 
            in the digital space.
          </p>

        </div>

      </div>
    </section>
    

<section className="why-choose-section">

  <div className="why-bg-icons" aria-hidden="true">
    {[...Array(6)].map((_, i) => (
      <span key={i} className={`why-bg-icon why-bg-icon--${i + 1}`}>
        <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="5" width="50" height="50" rx="6" stroke="currentColor" strokeWidth="2" />
          <rect x="14" y="18" width="32" height="4" rx="2" fill="currentColor" opacity="0.4" />
          <rect x="14" y="28" width="22" height="4" rx="2" fill="currentColor" opacity="0.3" />
          <rect x="14" y="38" width="28" height="4" rx="2" fill="currentColor" opacity="0.2" />
        </svg>
      </span>
    ))}
  </div>

  <div className="why-container">

    <div className="why-heading-wrapper">
      <h2 className="why-heading">
        Why Choose <span className="why-heading-badge">NamoDigital Hub</span>
      </h2>
      <p className="why-subtext">
        Choosing NamoDigital Hub is not just a decision; it's an investment in
        transformative digital experiences. Elevate your brand, engage your audience,
        and surpass your digital goals with a partner dedicated to your success.
        Your ROI is our benchmark for success.
      </p>
    </div>

    <div className="why-cards-grid">

      <div className="why-card">
        <h3 className="why-card-title" style={{ color: "#3b3bbf" }}>Web Company</h3>
        <p className="why-card-desc">
          Being the best Web company in India is a result of our complete focus on
          and mastery of PPC. Nobody is as knowledgeable about PPC as we are, we assure you.
        </p>
        <button className="why-card-btn" onClick={handleContactClick}>Contact Us</button>
      </div>

      <div className="why-card">
        <h3 className="why-card-title" style={{ color: "#e8650a" }}>Tactics for Success</h3>
        <p className="why-card-desc">
          We don't approach every project with the same strategy, in contrast to other
          companies. Every website has a distinct area of expertise and differs from
          the others in some way.
        </p>
        <button className="why-card-btn" onClick={handleContactClick}>Contact Us</button>
      </div>

      <div className="why-card">
        <h3 className="why-card-title" style={{ color: "#3b3bbf" }}>Building Your Business</h3>
        <p className="why-card-desc">
          We solely concentrate on Digital and IT services and have mastered them,
          which is why we are the top digital firm in India. We promise that no one
          knows the Web as well as we do.
        </p>
        <button className="why-card-btn" onClick={handleContactClick}>Contact Us</button>
      </div>

    </div>
  </div>

</section>


    

      {/* CTA Section */}
      <section className="about-cta">
        <div className="about-container">
          <h2 className="cta-heading">Ready to Get Started?</h2>
          <p className="cta-text">
            Let's work together to transform your business and achieve your digital goals.
          </p>
          <button className="cta-button" onClick={handleContactClick}>
            Contact Us
          </button>
        </div>
      </section>


    </div>
  );
}

export default About;
